<template>
  <section class="intake">
    <template v-if="currentSite === 'inboedelopslag'">
      <NavigationStorage />

      <IntakeTab v-show="activeTab === 'intake'" />
      <ClientTab v-show="activeTab === 'client'" />
      <AdditionTab v-show="activeTab === 'addition'" />
    </template>

    <template v-else>
      <Navigation />

      <ClientTab v-show="activeTab === 'client'" />
      <AddressTab v-show="activeTab === 'address'" />
      <IntakeTab v-show="activeTab === 'intake'" />
      <AdditionTab v-show="activeTab === 'addition'" />
    </template>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import Navigation from '@/intake/components/Navigation.vue';
import NavigationStorage from '@/intake/components/NavigationStorage.vue';
import ClientTab from '@/intake/components/ClientTab.vue';
import AddressTab from '@/intake/components/AddressTab.vue';
import IntakeTab from '@/intake/components/IntakeTab.vue';
import AdditionTab from '@/intake/components/AdditionTab.vue';

export default {
  components: {
    Navigation,
    NavigationStorage,
    ClientTab,
    AddressTab,
    IntakeTab,
    AdditionTab,
  },

  computed: {
    ...mapGetters([
      'currentSite',
      'activeTab',
    ]),
  },
};
</script>
